// Pages for Convenor staff (PLATFORM_ADMINS; not sitemap screens).
import { extra, page, type AreaRoute } from "../../routes/types";

export const routes: AreaRoute[] = [
  extra("/staff/emails", page(() => import("./pages/EmailLogPage"), "EmailLogPage"), { allowNoOrg: true }),
  extra("/staff/trials", page(() => import("./pages/TrialsPage"), "TrialsPage"), { allowNoOrg: true }),
  extra("/staff/organisations/new", page(() => import("./pages/NewOrganisationPage"), "NewOrganisationPage"), { allowNoOrg: true }),
];
